import { render, staticRenderFns } from "./student-view.vue?vue&type=template&id=54c80d26&"
import script from "./student-view.vue?vue&type=script&lang=js&"
export * from "./student-view.vue?vue&type=script&lang=js&"
import style0 from "./student-view.vue?vue&type=style&index=0&id=54c80d26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports